import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import moment from 'moment'
import fontSize from './util/fontSize'
import setRootFontSize from './util/rem'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
window.g.isRem && setRootFontSize(document, window)

Vue.use(Antd);

Vue.prototype.$Moment = moment
Vue.prototype.$FontSize = fontSize

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
